export interface IconBlobEntry {
  key: string;
  mime?: string;
  size?: number;
  createdAt?: Date;
}

/**
 * Lets the custom icon panel offer images that are already stored in the
 * workspace. The component package knows nothing about workspaces, so the
 * app registers the source of the current workspace.
 */
export interface IconBlobSource {
  list: () => Promise<IconBlobEntry[]>;
  getUrl: (key: string) => Promise<string | undefined>;
}

let currentSource: IconBlobSource | undefined;

export const registerIconBlobSource = (source: IconBlobSource | undefined) => {
  currentSource = source;
};

export const getIconBlobSource = () => currentSource;
